const saleRoutes = {
  index: {
    path: 'index.scrapping.sale',
    url: '/vente',
  },
  new: {
    path: 'index.scrapping.sale.new',
    url: '/creer',
  },
  consult: {
    path: 'index.scrapping.sale.consult',
    url: '/consulter',
  },
  details: {
    path: 'index.scrapping.sale.details',
    url: '/details',
  },
  edit: {
    path: 'index.scrapping.sale.edit',
    url: '/modifier',
  },
  pieces: {
    path: 'index.scrapping.sale.pieces',
    url: '/pieces',
  },
  axletrees: {
    path: 'index.scrapping.sale.axletrees',
    url: '/essieux',
  },
  steriles: {
    path: 'index.scrapping.sale.steriles',
    url: '/steriles',
  },
  generateBLWagons: {
    path: 'index.scrapping.sale.generateBLWagons',
    url: '/blwagons',
  },
  generateBLEssieux: {
    path: 'index.scrapping.sale.generateBLEssieux',
    url: '/blessieux',
  },
}

export default saleRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/sale/routes.js